<template>
  <div class="rates-display">
    <div class="container-fluid rates-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="background">
            <div class="text-center why-gsc">
              <h2>Sign up Today!</h2>
              <a v-link="{ path: '/sign-up' }" class="btn btn-success btn-lg">Rates</a>
              <a v-link="{ path: '/sign-up' }" class="btn btn-success btn-lg">Join Now</a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="header-bar">
            <div class="panel panel-default">
              <div class="panel-heading">
                <h3 class="panel-title">Why GreenShareCar?</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <h4>Born in Melbourne for Melbournians.</h4>
          <h4 class="fine-print-heading">Why GreenShareCar?</h4>
          <ul>
            <li class="h5"><strong>Special overnight rates for all CBD vehicles when reserved between 5PM &ndash; 8AM.</strong></li>
            <li class="h5"><strong>Special weekend rates for all CBD vehicle bookings when reserved after 5PM Friday and returned by 8AM Monday.</strong></li>
            <li class="h5"><strong>Unlimited Kilometers available with every trip regardless of selected plan or trip durations (within Victoria only).</strong></li>
            <li class="h5"><strong>FREE membership and discounted rates for students and seniors.</strong></li>
            <li class="h5"><strong>Plans to suit every individual or business.</strong></li>
            <li class="h5"><strong>Well kept vehicles, that are maintained in-house with a professional team of car detailers who check safety items frequently.</li>
            <li class="h5"><strong>All GreenShareCars come equipped with alloy wheels as standard with most having leather trim with GPS. We don't use baseline models.</strong></li>
            <li class="h5"><strong>We have vehicles for all occasions, from sedans, 4WD, vans and buses.</strong></li>
            <li class="h5"><strong>GreenShareCar uses the latest technologies as they emerge to better serve our members, including an easy to use booking system compatible with mobile devices.</strong></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhyGSC'
}
  </script>



// WEBPACK FOOTER //
// WhyGSC.vue?d10dea20